import BaseModalHandler from './base-modal-handler'
import DocumentSelect from '@app/application/reconciliation/handlers/live_inputs/document_select'

import type { DocumentModalOptions } from '../types'

export default class DocumentSelectModalHandler extends BaseModalHandler {
  private initializedModal?: DocumentSelect
  private loadingModalInProgress: boolean

  constructor() {
    super()
    this.loadingModalInProgress = false
  }

  open({ firmId, companyId, options }: DocumentModalOptions): void {
    if (this.loadingModalInProgress) return

    this.loadingModalInProgress = true

    if (this.initializedModal) {
      this.initializedModal.closeModal()
    }

    this.initializedModal = new DocumentSelect({
      firmId,
      companyId,
      settings: options,
    })
  }

  modalOpened(): void {
    this.loadingModalInProgress = false
  }
}
